import { QUERY_KEYS_SIH } from '../../../Common/hooks/useChartsData';

export const subtitlesMap = {
    [QUERY_KEYS_SIH.GENERAL_RESULTS_AIH]: [
        {
            type: '00',
            description: 'Total de AIH',
            color: ['#6FB9F8', '#08DCD4']
        }
    ]
};
